import React, {useEffect, useState} from "react"
import { GatsbyImage } from "gatsby-plugin-image";
import { PortalWithState } from 'react-portal';

import "react-responsive-carousel/lib/styles/carousel.min.css"
import { Carousel } from "react-responsive-carousel"
import arrow from '../assets/images/arrow.svg'
import cross from '../assets/images/cross.svg'
import { useWindowSize } from '../utils/use-window-size.js'

const Gallery = ({ gallery, mode }) => {

  const windowSize = useWindowSize();
  const [modalOpen, setModalOpen] = useState(false);


  const opened =  () => document.body.style.overflow = 'hidden';
  const closed = () => document.body.style.overflow = 'unset';

  const portalRoot = typeof document !== `undefined` ? document.getElementById('portal') : null
  if (gallery === null || gallery === undefined) {
    return (<div></div>)
  }
  const images = gallery.map(({ altText, localFile: { childImageSharp } }, index) => {
    if (mode !== "banner") {
      return (<div key={index} >
        <GatsbyImage alt={altText} image={childImageSharp.gatsbyImageData} />
      </div>)
    }
    return (
      <PortalWithState key={index} closeOnOutsideClick onOpen={opened} onClose={closed} closeOnEsc node={portalRoot}>
      {({ openPortal, closePortal, isOpen, portal }) => {
        return (
    <React.Fragment>
      <div key={index} onClick={openPortal} className={"p-3"}>
        <GatsbyImage image={childImageSharp.gatsbyImageData} alt={altText}/>
      </div>
      {portal(
        <div key={`pop-${index}`} className="fixed top-0 left-0 w-full h-full bg-black z-10 bg-opacity-50 flex place-items-center place-content-center" onClick={closePortal}>
        <div className="w-full lg:w-1/2 relative">
        <button className="absolute top-0 right-0 z-10 text-white p-8" onClick={closePortal}>
        <img alt="" src={cross} className="w-6" />
        </button>
        <GatsbyImage image={childImageSharp.gatsbyImageData} className="h-full" imgStyle={{ objectFit: 'contain' }} onClick={() => false} alt={altText} />
        </div>
        </div>
      )}
    </React.Fragment>
  )}}
      </PortalWithState>
    )
  })
  const arrowStyles = {
    position: "absolute",
    zIndex: 2,
    top: 0,
    width: 60,
    height: '94%',
    cursor: "pointer",
  }
  const buttonClass = "w-12 align-middle text-middle mx-auto hover:bg-black transition transition-colors hover:bg-opacity-30 backdrop-filter backdrop-grayscale my-0 lg:my-3 flex"

  return (
    <div className={ mode == "banner" ? "md:px-20 px-5" : "min-w-32 lg:min-h-20 w-full"}>
      <style type="text/css">
        {` .carousel .slide {
          background: var(--color-page);
          border: 1px solid var(--color-page);
        }`}
      </style>
      {gallery === null ? (
        <></>
      ) : (
        <Carousel
          showStatus={false}
          showIndicators={false}
          infiniteLoop={mode !== "banner"}
          dynamicHeight={false}
          centerMode={mode === "banner"}
          centerSlidePercentage={windowSize.width > 1024 ? 35 : 80}
          autoPlay={true}
          interval={4000}
          showThumbs={false}
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev && (
              <div
                type="button"
                onClick={onClickHandler}
                title={label}
                className={buttonClass}
              style={{ ...arrowStyles, left: 0 }}
              >
                <img src={arrow} style={{ position: 'relative' }} className="p-4"  />
              </div>
            )
          }
          renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext && (
              <div
                type="button"
                onClick={onClickHandler}
                title={label}
                className={buttonClass}
                style={{ ...arrowStyles, right: 0 }}
              >
                <img src={arrow} style={{ position: 'relative', transform: 'rotate(180deg)' }} className="p-4" />
              </div>
            )
          }
        >
          {images}
        </Carousel>
      )}
    </div>
  )
}

export default Gallery
